module.exports = __webpack_public_path__ + "static/media/poo.b268be7c.svg";